import { api, ReactQueryOptions } from '@api';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['SocialManager']['unfollow'];
export const useUnfollow = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    updateFollowData
  } = useInvalidate();
  const utils = api.useContext();
  return api.SocialManager.unfollow.useMutation({
    mutationKey: ['SocialManager.unfollow'],
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onSuccess: async (data, variables) => {
      if (data.status === 'success') {
        const profile = utils.UserManager.getProfile.getData();
        const shortId = profile?.shortid;
        updateFollowData({
          shortId: variables.shortid
        });
        if (typeof shortId === 'string') updateFollowData({
          shortId
        });
      }
      showToast({
        variant: 'success'
      });
    },
    ...options
  });
};